export default __webpack_public_path__ + "static/media/TabTwo.05e99980.png";